import script from "./CustomDashboardProgressModule.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardProgressModule.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardProgressModule.vue?vue&type=style&index=0&id=038e704a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038e704a"]])

export default __exports__